import moment from 'moment'
import _ from 'lodash'


export function returnDateFormated(d, start=true) {
  d = _.isString(d) ? moment(d) : d
  return d.local().format('YYYY-MM-DDTHH:mmZ')
}

export function returnDateLocal(d, start=true) {
  d = _.isString(d) ? moment(d) : d
  return d.local()
}
